module.exports = function() {
  return new Worker(__webpack_public_path__ + "df5781bd3587f4f223e6.worker.js");
};